import React from "react";
import { ForneiroProvider } from "./context/ForneiroContext";
import ForneiroContent from "./components/ForneiroContent";

const Forneiro: React.FC = () => {
  return (
    <ForneiroProvider>
      <ForneiroContent />
    </ForneiroProvider>
  );
};

export default Forneiro;
